import Form from "antd/lib/form/Form";
import React, { useContext, useEffect, useRef, useState } from "react";
import Wizard from "./Wizard";
import QalortButton from "../../Button";
import RadioButton from "../../radio/RadioButton";
import BaseInput from "../../BaseInput";
import SvgCalendar from "../../../icons/SvgCalendar";
import { DatePicker, notification, Select, TimePicker } from "antd";
import BaseSelect from "../../BaseSelect";
import clock from "../../../assets/Clock.svg";
import {
  DAILY,
  frequencyTypes,
  MONTHLY,
  ONCE,
  WEEKLY,
} from "../../cohort/cohorts.constants";
import dayjs from "dayjs";
import ScheduleTable from "../../cohort/ScheduleTable";
import NewSessionModal from "../../cohort/NewSessionModal";
import { AppContext } from "../../../context";

function PricingAndSchedule({
  handleProceed,
  isOpen,
  isDone,
  handleBack,
  hopToLevel,
}) {
  const { formFields, updateContext } = useContext(AppContext);
  const dateFormat = "YYYY-MM-DD";
  const [pricing, setPricing] = useState(!formFields?.price ? "Free" : "Paid");
  const [visible, setVisible] = useState(false);
  const [recurringSchedule, setRecurringSchedule] = useState(
    !!formFields?.frequency || null
  );
  const [step2Form] = Form.useForm();
  const { frequency } = formFields;
  const [schedules, setSchedules] = useState(formFields.schedules || []);
  const [newSchedule, setNewSchedule] = useState({});
  let clearTimerRef = useRef();

  const clearDatesAndSchedule = () => {
    step2Form.setFieldValue("start_time", null);
    step2Form.setFieldValue("end_time", null);
    step2Form.setFieldValue("start_date", null);
    step2Form.setFieldValue("end_date", null);
    setNewSchedule({});
    setSchedules([]);
    updateContext({
      ...formFields,
      start_time: null,
      end_time: null,
      start_date: null,
      end_date: null,
      schedules: [],
    });
  };

  useEffect(() => {
    schedules.length &&
      updateContext({
        ...formFields,
        schedules,
      });
  }, [schedules]);

  useEffect(() => {
    let data = formFields;
    if (formFields.start_date) {
      data.start_date = dayjs(formFields.start_date);
    }
    if (data?.schedules?.length > 0) {
      data.start_time = dayjs("1/1/1 " + formFields.schedules[0]?.start_time);
      data.end_time = dayjs("1/1/1 " + formFields.schedules[0]?.end_time);
    }

    if (formFields.frequency === ONCE) {
      setRecurringSchedule(null);
      setNewSchedule({
        ...newSchedule,
        start_date: formFields?.start_date
          ? formFields?.start_date.format("YYYY-MM-DD")
          : null,
      });
    }
    step2Form.setFieldsValue(data);
  }, [step2Form]);

  return (
    <>
      <Form
        form={step2Form}
        onFinish={() => {
          if (!pricing) {
            notification.error({
              message: "Please select a pricing option",
            });
            return;
          }
          if (recurringSchedule === undefined) {
            notification.error({
              message: "Please select a scheduling option",
            });
            return;
          }
          if (!formFields.end_date) {
            updateContext({ ...formFields, end_date: formFields.start_date });
          }

          if (recurringSchedule === null) {
            updateContext({ ...formFields, frequency: ONCE });
          }
          handleProceed();
        }}
      >
        <Wizard
          {...{ isOpen }}
          {...{ isDone }}
          step="2"
          details="Pricing and Schedule"
          onClickHeader={() => {
            hopToLevel(2);
          }}
        >
          <div className="px-5 md:px-[62px]">
            <div className="py-[7px] px-3 w-full bg-light-tint mb-6">
              <p className="p-xs mb-0 font-medium text-dark">Pricing</p>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex gap-4">
                <RadioButton
                  testid="pricing_free"
                  title="Free"
                  className="flex-1"
                  value="Free"
                  isChecked={pricing === "Free"}
                  onChange={(e) => {
                    setPricing(e);
                    updateContext({ ...formFields, price: 0 });
                  }}
                />
                <RadioButton
                  title="Paid"
                  className="flex-1"
                  value="Paid"
                  isChecked={pricing === "Paid"}
                  onChange={(e) => {
                    setPricing(e);
                  }}
                />
              </div>

              {pricing === "Paid" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <BaseSelect
                    className="w-full"
                    options={[
                      { value: "USD", label: "USD" },
                      {
                        value: "NGN",
                        label: "NGN",
                      },
                    ]}
                    value={formFields.currency}
                    onChange={(e) => {
                      updateContext({
                        ...formFields,
                        currency: e,
                      });
                    }}
                  />
                  <BaseInput
                    placeholder="Enter an amount"
                    type="number"
                    suffixClassName="right-4"
                    onChange={(e) => {
                      updateContext({
                        ...formFields,
                        price: Number(e.target.value),
                      });
                    }}
                    value={formFields.price}
                  ></BaseInput>
                </div>
              )}
            </div>

            <div>
              <div className="py-[7px] px-3 w-full bg-light-tint mb-6 mt-[44px]">
                <p className="p-xs mb-0 font-medium text-dark">Schedule</p>
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex gap-4">
                  <RadioButton
                    title="One time"
                    className="flex-1"
                    value="One time"
                    isChecked={recurringSchedule === null}
                    onChange={() => {
                      setRecurringSchedule(null);
                      updateContext({
                        ...formFields,
                        frequency: ONCE,
                        schedules: [],
                      });
                      clearDatesAndSchedule();
                    }}
                  />
                  <RadioButton
                    title="Recurring"
                    className="flex-1"
                    value="Recurring"
                    isChecked={Boolean(recurringSchedule)}
                    onChange={() => {
                      setRecurringSchedule(true);
                      clearDatesAndSchedule();
                    }}
                  />
                </div>
                {recurringSchedule === null && (
                  <div>
                    <div className="mt-4">
                      <div className="w-full">
                        <label className="text-main font-medium p-xs">
                          Date
                        </label>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Please select a date!",
                            },
                          ]}
                          name="start_date"
                          valuePropName="start_date"
                          className="!mb-0"
                        >
                          <DatePicker
                            data-testid="date-picker"
                            dropdownClassName="date-picker-content"
                            // data-testid="start_date"
                            className="recurring-date"
                            id="date_input"
                            placeholder="DD/MM/YY"
                            suffixIcon={<SvgCalendar className="text-light" />}
                            style={{
                              borderRadius: "0.5rem",
                              border: "1px solid #eceef8",
                              fontSize: "0.9375rem",
                              backgroundColor: "#fff",
                              height: 56,
                              width: "100%",
                              color: "#30307d",
                            }}
                            disabledDate={(current) =>
                              current.isBefore(dayjs().format("YYYY-MM-DD"))
                            }
                            value={
                              newSchedule.start_date
                                ? dayjs(newSchedule.start_date)
                                : ""
                            }
                            onChange={(e) => {
                              updateContext({
                                ...formFields,
                                start_date: e ? e.format("YYYY-MM-DD") : null,
                              });
                              setNewSchedule({
                                ...newSchedule,
                                start_date: e.format("YYYY-MM-DD"),
                              });
                              clearTimerRef.current = setTimeout(() => {
                                setSchedules([
                                  {
                                    ...schedules[0],
                                    date: e ? e.format("YYYY-MM-DD") : null,
                                  },
                                ]);
                              }, 500);
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="flex gap-4 mt-4">
                      <div className="w-full">
                        <label className="text-main font-medium p-xs">
                          Start Time
                        </label>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Please select a start time!",
                            },
                          ]}
                          name="start_time"
                          className="!mb-0"
                        >
                          <TimePicker
                            data-testid="start_time"
                            className="recurring-date"
                            placeholder="8:00"
                            suffixIcon={<img src={clock} alt="" />}
                            use12Hours
                            minuteStep={30}
                            showSecond={false}
                            changeOnBlur={true}
                            popupClassName="one_time_start_time"
                            style={{
                              borderRadius: "0.5rem",
                              border: "1px solid #eceef8",
                              fontSize: "0.9375rem",
                              backgroundColor: "#fff",
                              height: 56,
                              width: "100%",
                              color: "#30307d",
                            }}
                            onChange={(e) => {
                              setSchedules([
                                {
                                  ...schedules[0],
                                  start_time: e.format("HH:mm"),
                                },
                              ]);
                            }}
                          />
                        </Form.Item>
                      </div>

                      <div className="w-full">
                        <label className="text-main font-medium p-xs">
                          End Time
                        </label>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Please select an end time!",
                            },
                          ]}
                          name="end_time"
                          className="!mb-0"
                        >
                          <TimePicker
                            data-testid="end_time"
                            className="recurring-date"
                            placeholder="10:00"
                            suffixIcon={<img src={clock} alt="" />}
                            use12Hours
                            minuteStep={30}
                            showSecond={false}
                            changeOnBlur={true}
                            popupClassName="one_time_end_time"
                            style={{
                              borderRadius: "0.5rem",
                              border: "1px solid #eceef8",
                              fontSize: "0.9375rem",
                              backgroundColor: "#fff",
                              height: 56,
                              width: "100%",
                              color: "#30307d",
                            }}
                            onChange={(e) => {
                              setSchedules([
                                {
                                  ...schedules[0],
                                  end_time: e.format("HH:mm"),
                                },
                              ]);
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )}

                {recurringSchedule === true && (
                  <>
                    {/* // <Form onSubmitCapture={setFormSchedule} form={recurringForm}> */}
                    <div className="flex flex-col gap-5">
                      <div className="grid gap-4 grid-cols-2">
                        <div className="w-full">
                          <label className="text-main font-medium p-xs">
                            Start Date
                          </label>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please select a date!",
                              },
                            ]}
                            name="start_date"
                            className="!mb-0"
                            valuePropName="start_date"
                          >
                            <DatePicker
                              className="recurring-date"
                              dropdownClassName="recurring-start-date"
                              id="date_input"
                              placeholder="DD/MM/YY"
                              suffixIcon={
                                <SvgCalendar className="text-light" />
                              }
                              format={dateFormat}
                              style={{
                                borderRadius: "0.5rem",
                                border: "1px solid #eceef8",
                                fontSize: "0.9375rem",
                                backgroundColor: "#fff",
                                height: 56,
                                width: "100%",
                                color: "#30307d",
                              }}
                              disabledDate={(current) =>
                                current.isBefore(dayjs().format("YYYY-MM-DD"))
                              }
                              onChange={(e) =>
                                updateContext({
                                  ...formFields,
                                  start_date: e.format("YYYY-MM-DD"),
                                })
                              }
                              defaultValue={
                                formFields.start_date
                                  ? dayjs(formFields.start_date)
                                  : null
                              }
                            />
                          </Form.Item>
                        </div>
                        <div className="w-full">
                          <label className="text-main font-medium p-xs">
                            End Date
                          </label>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: "Please select an end date!",
                              },
                            ]}
                            name="end_date"
                            className="!mb-0"
                            valuePropName="end_date"
                          >
                            <DatePicker
                              data-testid="end_date"
                              className="recurring-date"
                              dropdownClassName="recurring-end-date"
                              id="date_input"
                              placeholder="DD/MM/YY"
                              suffixIcon={
                                <SvgCalendar className="text-light" />
                              }
                              format={dateFormat}
                              style={{
                                borderRadius: "0.5rem",
                                border: "1px solid #eceef8",
                                fontSize: "0.9375rem",
                                backgroundColor: "#fff",
                                height: 56,
                                width: "100%",
                                color: "#30307d",
                              }}
                              disabledDate={(current) =>
                                current.isBefore(dayjs().format("YYYY-MM-DD"))
                              }
                              defaultValue={
                                formFields.end_date
                                  ? dayjs(formFields.end_date)
                                  : null
                              }
                              onChange={(e) => {
                                updateContext({
                                  ...formFields,
                                  end_date: e.format("YYYY-MM-DD"),
                                });
                              }}
                            />
                          </Form.Item>
                        </div>
                        <div className="w-full">
                          <BaseSelect
                            testid="frequency"
                            label="Add Frequency"
                            placeholder="eg. Weekly"
                            name="frequency"
                            selectClassName="h-14"
                            rules={[
                              {
                                required: true,
                                message: "Please select a frequency!",
                              },
                            ]}
                            options={frequencyTypes.map((type) => ({
                              value: type,
                              label: type,
                            }))}
                            onChange={(frequency) => {
                              updateContext({
                                ...formFields,
                                frequency,
                                schedules: [],
                              });
                              // clearDatesAndSchedule();
                              setNewSchedule({});
                            }}
                          />
                        </div>
                        {![DAILY, ONCE].includes(frequency) ? (
                          <div className="w-full">
                            <div
                              onClick={() => {
                                if ([WEEKLY, MONTHLY].includes(frequency)) {
                                  setVisible(true);
                                } else {
                                  notification.info({
                                    message:
                                      "Please select a frequency option first",
                                  });
                                }
                              }}
                              className="!py-4 mt-6 w-full flex items-center justify-center text-sm px-4 mr-2 rounded-md border-pri bg-pri text-white"
                            >
                              Add new session
                            </div>
                          </div>
                        ) : (
                          <div className="w-full"></div>
                        )}
                      </div>
                      <div className="w-full">
                        {[DAILY, ONCE].includes(frequency) && (
                          <div className="flex gap-4">
                            <div className="w-full">
                              <label className="text-main font-medium p-xs">
                                Start Time
                              </label>
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select a start time!",
                                  },
                                ]}
                                name="start_time"
                                className="!mb-0"
                              >
                                <TimePicker
                                  data-testid="start_time"
                                  popupClassName="recurring_start_time"
                                  className="recurring-date"
                                  placeholder="e.g 8:00"
                                  suffixIcon={<img src={clock} alt="" />}
                                  use12Hours
                                  minuteStep={30}
                                  showSecond={false}
                                  changeOnBlur={true}
                                  style={{
                                    borderRadius: "0.5rem",
                                    border: "1px solid #eceef8",
                                    fontSize: "0.9375rem",
                                    backgroundColor: "#fff",
                                    height: 56,
                                    width: "100%",
                                    color: "#30307d",
                                  }}
                                  onChange={(e) => {
                                    setSchedules([
                                      {
                                        ...schedules[0],
                                        start_time: e.format("HH:mm"),
                                      },
                                    ]);
                                  }}
                                />
                              </Form.Item>
                            </div>
                            <div className="w-full">
                              <label className="text-main font-medium p-xs">
                                End Time
                              </label>
                              <Form.Item
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select an end time!",
                                  },
                                ]}
                                name="end_time"
                                className="!mb-0"
                              >
                                <TimePicker
                                  data-testid="end_time"
                                  popupClassName="recurring_end_time"
                                  className="recurring-date"
                                  placeholder="e.g 10:00"
                                  suffixIcon={<img src={clock} alt="" />}
                                  use12Hours
                                  minuteStep={30}
                                  showSecond={false}
                                  changeOnBlur={true}
                                  style={{
                                    borderRadius: "0.5rem",
                                    border: "1px solid #eceef8",
                                    fontSize: "0.9375rem",
                                    backgroundColor: "#fff",
                                    height: 56,
                                    width: "100%",
                                    color: "#30307d",
                                  }}
                                  onChange={(e) => {
                                    setSchedules([
                                      {
                                        ...schedules[0],
                                        end_time: e.format("HH:mm"),
                                      },
                                    ]);
                                  }}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {!!formFields?.schedules?.length && <ScheduleTable />}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="border-t border-grey-2 py-3.5 mt-9">
            <div className="flex gap-2.5 justify-end px-5 md:px-[62px]">
              <button
                className="border border-pri bg-pri-tint-3 pri py-2 px-9 rounded-md"
                onClick={() => {
                  handleBack();
                }}
                type="button"
              >
                Back
              </button>
              <QalortButton type="primary" className="py-3 px-9 rounded-md">
                Proceed
              </QalortButton>
            </div>
          </div>
        </Wizard>
      </Form>

      <NewSessionModal
        visible={visible}
        setVisible={setVisible}
        setNewSchedule={setNewSchedule}
        newSchedule={newSchedule}
        frequency={frequency}
        setSchedules={setSchedules}
      />
    </>
  );
}

export default PricingAndSchedule;
